<div *ngIf="data.mobileType === 'android'" class="android-prompt">
    <button class="close-button" mat-button color="primary" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
    <div class="body-container w-100">
        <div class="align-items-center p-0">
            <img [src]="imgService.getImage('logo512x512.png')" height="50" (error)="imgService.onImgError('logo512x512.png', $event)">&nbsp;
            <!-- <img height=50 src="assets/icons/SOS_android_512_b.png">&nbsp; -->
            <span>{{imgService.appName}}</span>
            <button class="add-button" mat-raised-button (click)="installPwa()" [style.background-color]="imgService.themeColor">Agregar al Escritorio</button>
        </div>
    </div>
</div>

<div *ngIf="data.mobileType === 'ios'" class="ios-prompt">
    <button class="close-button" mat-button color="primary" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
    <div>Para instalar esta aplicación en su dispositivo, click en <b>Menu</b> y seleccione '<b>Agregar al Inicio</b>'</div>
    <div style="padding: 10px 0;">
        <img src="assets/images/ios-menu-btn.png">
        <mat-icon>navigate_next</mat-icon>
        <img src="assets/images/ios-add-btn.png">
    </div>
</div>